import React, { useEffect } from "react";
import Fade from "react-reveal/Fade";
import { useContent } from "../../hooks/useContent";
import { useTranslation } from "react-i18next";

const Arcelia = () => {
  const { about, fetchAbout } = useContent();
  const { i18n } = useTranslation()

  useEffect(() => {
    fetchAbout();
  }, [i18n.language]);

  return (
    <Fade bottom>
      <div className="m-2 md:py-20 md:px-60 text-lg font-medium" style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
        <p>{about?.about_content}</p>
        <div className="py-10 flex md:flex-row flex-col gap-5">
          <div>
            <h1 className="text-xl font-semibold">
              <div className="h-3 w-6 bg-purple inline-block mx-2"></div>
              {/* التسويق العقاري */}
              {about?.about_1_title}
            </h1>
            <p>
              {/* تتخصص شركات “أرسيليا” في طيف واسع ومجموعة متنوعة من الخدمات؛ من
              أهمها خدمات التقييم العقاري والتسويق */}
              {about?.about_1_content}
            </p>
          </div>
          <div>
            <h1 className="text-xl font-semibold">
              <div className="h-3 w-6 bg-purple inline-block mx-2"></div>
              {/* التقييم العقاري */}
              {about?.about_2_title}
            </h1>
            <p>
              {/* تتخصص شركات “أرسيليا” في طيف واسع ومجموعة متنوعة من الخدمات؛ من
              أهمها خدمات التقييم العقاري والتسويق */}
              {about?.about_2_content}
            </p>
          </div>
          <div>
            <h1 className="text-xl font-semibold">
              <div className="h-3 w-6 bg-purple inline-block mx-2"></div>
              {/* تنظيم المؤتمرات والمعارض */}
              {about?.about_3_title}
            </h1>
            <p>
              {/* تتخصص شركات “أرسيليا” في طيف واسع ومجموعة متنوعة من الخدمات؛ من
              أهمها خدمات التقييم العقاري والتسويق */}
              {about?.about_3_content}
            </p>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Arcelia;
